/**
 * Classe responsável por realizar transformacoes em layouts.
 *
 * @author: kete
 * Date: 01/04/14
 */

Monet.PageLayout = Monet.PageLayout || {};

Monet.PageLayout = (function () {

    function PageLayout (pageLayout) {

        this.getFields = function () {

            var error           = null,
                fields          = [],
                iterateSections = null;

            try {

                iterateSections = function (sections) {

                    for (var property in sections) {

                        if (typeof sections[property] === 'object') {

                            if (property === 'field') {

                                var field = sections[property];
                                var filedNotIsLink = field.type !== 'LINK';

                                if (filedNotIsLink) {
                                    fields.push(sections[property]);
                                }

                            } else {

                                iterateSections(sections[property]);

                            }

                        }
                    }

                };

                if (pageLayout.hasOwnProperty('sections')) {

                    for (var i = 0; i < pageLayout.sections.length; i++) {

                        iterateSections(pageLayout.sections[i]);

                    }

                } else {

                    error = new Monet.Exception.ReturnError(this,
                        'Layout is not ok.');
                    error.console();

                }

            } catch (e) {

                error = new Monet.Exception.ReturnError(this,
                    'Error on get field from layout', e);
                error.console();

            }

            return fields;

        };

        this.getLayout = function (entity, action, callback, namespace) {

            var ajax = new Monet.Ajax();

            namespace = namespace || entity;

            ajax.url = 'form/' + entity + '/' + action;

            ajax.success = function (data) {
                if (data) {
                    App.Forms[namespace].layout[action] = data;
                    if (callback) {
                        callback();
                    }
                }
            };

            ajax.send();
        };

    }

    return PageLayout;

})();